module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#youtube",
      toString: function () {
        return this.url;
      }
    }